<template lang="html">
  <div class="content internet">
    <clueFilter ref="clueFilter" :type="source_type" v-on:filterData="getFilters" />
    <div class="list">
      <div class="handles"></div>
      <skeleton v-show="waiting"></skeleton>
      <listItem v-show="!waiting" ref="listItem" :type="1" :list="list" :cate="true" v-on:getSort="getFilters" :showCreate="showCreate" :enablePush="enablePush" />
      <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total" />
    </div>
    <div class="notify" v-show="notify.show">
      <div class="titleline">
        <div class="title">
          <img src="@assets/img/common/notifyIcon.svg" alt="notify">
          <span>更新了一条新闻</span>
        </div>
        <img @click="notify.close()" class="close" src="@assets/img/common/notifyClose.svg" alt="close">
      </div>
      <div class="content">
        <div class="detail">
          <p class="body">{{notify.title}}</p>
          <p class="time">{{notify.time}}</p>
        </div>
        <div class="btn" @click="notify.jump()">查看</div>
      </div>
    </div>
  </div>
</template>

<script>
import clueFilter from '@components/clueFilter'
import listItem from '@components/listItem'
import common from '@common/common'
import { apis } from '@common/config'
import pages from '@components/pages'
import skeleton from "@components/skeleton";

export default {
  components: { clueFilter, listItem, pages, skeleton },
  data() {
    return {
      waiting: true,
      isXnew: this.$store.state.isXnew,
      list: null,
      filterOptions: {},
      searchOptions: {},
      source_type: 1,
      page: {
        pageIndex: 1,
        pageCount: 0,
        pageSize: 10,
        total: 0
      },
      showCreate: false,
      notify: {
        show: false,
        title: '',
        time: '',
        id: '',
        type: '',
        open: (data) => {
          this.$set(this.notify, 'title', data.title || data.body)
          this.$set(this.notify, 'time', data.time)
          this.$set(this.notify, 'id', data.id)
          this.$set(this.notify, 'type', data.type)
          this.$set(this.notify, 'show', true)
          setTimeout(() => {
            this.$set(this.notify, 'show', false)
          }, 4000)
        },
        close: () => {
          this.$set(this.notify, 'show', false)
        },
        jump: () => {
          if (this.notify.type !== 'weibo') {
            common.jump(`/clueDetail?d=${this.notify.id}`, true)
          }
        }
      },
      enablePush: false
    }
  },
  methods: {
    getFilters(data) {
      // 获取过滤条件数据
      // this.filterOptions = data
      if (data.hasOwnProperty('source_type')) {
        this.source_type = data['source_type'] - 0
        setTimeout(() => {
          // 同步执行会使用上次的source_type
          this.$refs.clueFilter.getData()
        }, 0)
      }

      this.filterOptions = Object.assign({}, data)
      this.page.pageIndex = 1
      this.list = null
      this.getList()
    },
    getList(keyWord) {
      // 获取列表数据
      this.waiting = true;
      const selectedTag = this.selectedTag || ''
      const id = this.$route.params.id
      const info = {
        idstring: id,
        pagesize: this.page.pageSize,
        page: this.page.pageIndex,
        medium_id: '',
        search_option: '',
        key_words: '',
        source_pid: '',
        source_sid: '',
        source_type: this.source_type,
        weibo_id: '',
        weixin_id: '',
        days: '',
        tags: selectedTag,
        has_file: ''
      }

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions, this.filterOptions)
      this.selectedTag = ''

      common.myFetch(apis.internetClue, info)
        .then((res) => {
          if (res) {
            res.list.forEach(el => {
              el.showPushBtns = false;
              el.showThreePoint = false;
            });
            this.list = res.list
            this.enablePush = !!res.reportExist
            this.generateSearchs(res.params.top_search.option.list)
            this.$set(this.page, 'pageCount', common.calculatePage(res.page.row_count - 0, this.page.pageSize))
            this.$set(this.page, 'total', res.page.row_count - 0)
            this.showCreate = res.has_add_role

            this.$nextTick(() => {
              this.waiting = false;
            })
          }
        })
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }
      this.postSearch(filterData)
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d
      this.page.pageIndex = 1
      this.getList()
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit('filterData', data)
    },
    getNotify(r) {
      const res = r.content || {}
      const data = {
        id: res.id,
        title: res.title,
        body: res.content,
        img: res.cover,
        type: res.source_type == '5' ? 'weibo' : 'others',
        time: res.raw_update_time
      }
      const info = {
        source_pid: res.source_pid
      }
      common.myFetch(apis.clue_notifyAuth, info)
        .then((r) => {
          if (r) {
            if (r.show_popup) {
              this.notify.open(data)
              // 手动加小红点
              this.$parent.$refs.slide.addDot('hulianwangxiansuo')
            }
          }
        })
    }
  },
  beforeDestroy() {
    this.$AiMessage(true)
  },
  mounted() {
    this.selectedTag = this.$route.params.tag
    if (!this.selectedTag) {
      this.source_type = 1
    }
    const selectedInternetType = this.$route.params.internetType

    if (selectedInternetType) {
      setTimeout(() => {
        this.$refs.listItem.toggleSort({ key: selectedInternetType })
      }, 0)
    } else {
      this.getList('noKeyWord')
    }
    common.handleSocket(this.getNotify, 'internetcluenotice')
    this.$AiMessage()
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.content.internet {
  display: flex;
  flex-direction: column;

  .clueFilter {
    margin-bottom: 30px;
  }
}

.notify {
  width: 420px;
  height: 120px;
  border-radius: 8px;
  border: 1px solid @green;
  background-color: #e6f1ed;
  position: fixed;
  right: 30px;
  bottom: 214px;
  padding: 0 20px;
  .titleline {
    height: 42px;
    padding: 6px 0 0;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(65, 180, 140, 0.15);
    .title {
      flex: 1;
      height: 20px;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: @green;
      span {
        margin-left: 10px;
        font-weight: bold;
      }
    }
    .close {
      cursor: pointer;
    }
  }
  .content {
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .detail {
      width: 280px;
      height: 40px;
      .body {
        font-size: 16px;
        color: @dark;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .time {
        font-size: 13px;
        color: @dateColor;
        font-weight: bold;
      }
    }
    .btn {
      width: 70px;
      height: 30px;
      border-radius: 100px;
      background-color: @green;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      line-height: 30px;
      text-align: center;
    }
  }
}

.list {
  display: flex;
  flex-direction: column;
  flex: 1;
  .boxOuter;
  padding-bottom: 50px;
}
</style>
